<template>
  <div class="sl_comments__reply">
    <div>
      <v-icon size="16">subdirectory_arrow_right</v-icon>
      Reply to:
      <span
        @click="scrollToComment"
        class="body-1 sl_comments__reply--text"
      >
        {{ commentText }}
      </span>
    </div>
    <a v-if="has_cancel" @click="cancel" class="sl_comments__reply--cancel ma-0">
      <v-icon size="16">close</v-icon>
    </a>
  </div>
</template>

<script>
  export default {
    name: 'CommentReply',
    props: ['comment', 'has_cancel'],
    methods: {
      cancel() {
        this.$emit('cancel')
      },
      scrollToComment() {
        this.$emit('requestScrollTo', this.comment.id);
      }
    },
    computed: {
      commentText() {
        if (this.comment && this.comment.text) {
          return this.comment.text.length > 100 ? `${this.comment.text.slice(0, 100)}...` : this.comment.text
        }
        return ''
      }
    }
  }
</script>
